import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export function UpgradeCTA() {
  return (
    <div className="relative ">
      <motion.svg
        viewBox="0 0 96 96"
        xmlns="http://www.w3.org/2000/svg"
        className="fill-sky-300/20 absolute right-0 -top-32 size-64 -ml-8 -z-10"
      >
        <motion.g
          transform="translate(0,96) scale(0.1,-0.1)"
          strokeWidth="3"
          className="stroke-sky-100/30"
        >
          <motion.path
            d="M800 879 c-25 -10 -98 -34 -162 -54 -91 -27 -125 -43 -152 -69 -39 -37 -81 -119 -91 -181 l-7 -40 53 51 c52 49 118 102 149 119 8 5 -26 -32 -76 -81 -50 -49 -104 -110 -120 -136 -29 -47 -30 -48 -81 -48 l-53 0 0 -34 0 -33 61 -7 c34 -3 86 -6 115 -6 l54 0 0 40 c0 36 -2 40 -25 40 -29 0 -30 2 -11 38 12 23 25 30 75 40 33 7 76 19 97 28 34 14 35 16 18 29 -17 13 -15 14 22 15 41 0 67 19 107 80 24 35 21 50 -10 51 -25 1 -24 3 9 12 33 9 40 17 57 61 24 67 33 106 24 105 -5 -1 -28 -9 -53 -20z"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 6, ease: "easeInOut" }}
          />
          <motion.path
            d="M287 310 c-4 -17 -14 -20 -60 -20 -32 0 -59 -5 -64 -12 -13 -16 -37 -194 -28 -208 9 -14 471 -14 480 0 9 14 -15 192 -28 208 -5 7 -32 12 -64 12 -46 0 -56 3 -60 20 -5 18 -14 20 -88 20 -74 0 -83 -2 -88 -20z"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 4, ease: "easeInOut" }}
          />
        </motion.g>
      </motion.svg>
      <motion.div
        className="border border-sky-300  rounded-md p-4 space-y-4 bg-sky-400/70"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div>
          <div className="text-white font-semibold">
            Streamline your GovCon process with SamSearch
          </div>
          <p className="text-sm text-sky-100 mt-1">
            Have any questions? Get in touch with the team
          </p>
        </div>
        <Button
          className="bg-sky-500 hover:bg-sky-500/80 border border-sky-300/70 w-full"
          onClick={() =>
            window.open("https://zcal.co/humamhwr/30minute", "_blank")
          }
        >
          Book Call
        </Button>
      </motion.div>
    </div>
  );
}
